module.exports = __webpack_public_path__ + "img/starttider.fb467f8a.jpg";